<template>
  <div class="container">
    <Loading v-show="isloading" />
    <router-view v-if="(status === 1)"></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from './components/loading'
import { GetStatus } from './api'
export default {
  name: 'App',
  components: {
    Loading
  },
  data() {
    return {
      status: 0
    }
  },
  computed: {
    ...mapState(['isloading'])
  },
  methods: {
    shareEvent() {
      var shareConfig = {
        link: window.location.href,
        title: "开启异世界的奇遇！寻惊喜好礼",
        desc: "参与即领免费十连和海量钻石奖励，更有机会获得食蜂操祈精美手办~",
        imgUrl: "https://static.web.sdo.com/xuezu/pic/20221201_Game/share.png",
        imgWidth: 80,
        imgHeigth: 80
      };
      CsLib.ShareEvent(shareConfig);
    },
    async getStatus() {
      const res = await GetStatus();
      if (res) {
        return this.status = 1;
      }
      return CsLib.pageClose('blood');
    }
  },
  mounted() {
    // 分享事件
    this.shareEvent();
    // 获取当前页面状态
    this.getStatus();
  }
}
</script>

<style lang="scss" scoped>

</style>